module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Lrkh"))).then(() => parcelRequire('d0iPb'));